const specialCommissions = {
  "PARRA TAMARA": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 40.000.000 de capital 11%",
    "-Desde $ 40.000.001 hasta $ 50.000.000 de capital 12%",
    "-Desde $ 50.000.001 hasta $ 60.000.000 de capital 13%",
    "-Más de $ 60.000.000 de capital 14%",
  ],
  "IBARRA MARCOS": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 40.000.000 de capital 11%",
    "-Desde $ 40.000.001 hasta $ 50.000.000 de capital 12%",
    "-Desde $ 50.000.001 hasta $ 60.000.000 de capital 13%",
    "-Más de $ 60.000.000 de capital 14%",
  ],
  "FALCON GRETA NATASHA": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 40.000.000 de capital 11%",
    "-Desde $ 40.000.001 hasta $ 50.000.000 de capital 12%",
    "-Desde $ 50.000.001 hasta $ 60.000.000 de capital 13%",
    "-Más de $ 60.000.000 de capital 14%",
  ],

  "IBARRA JUAN": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 60.000.000 de capital 11%",
    "-Más de $ 60.000.000 de capital 12%",
  ],
  "BERON MIGUEL ANGEL": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 60.000.000 de capital 11%",
    "-Más de $ 60.000.000 de capital 12%",
  ],
  "BERON DIEGO": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 60.000.000 de capital 11%",
    "-Más de $ 60.000.000 de capital 12%",
  ],
  "DE LUCA MATIAS": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 60.000.000 de capital 11%",
    "-Más de $ 60.000.000 de capital 12%",
  ],
  FINMARVI: ["-Comisión fija del 15%"],
  "COVELLI FRANCISCO": ["-Comisión fija del 12%"],
  "ALICO FEDERICO": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 60.000.000 de capital 11%",
    "-Más de $ 60.000.000 de capital 12%",
  ],
  "CLAVIJO CARLOS": [
    "-Hasta $ 15.000.000 de capital 11%",
    "-Más de $ 15.000.000 de capital 12%",
  ],
  "LUNGHITANO SANTIAGO": ["-Comisión fija del 12%"],
  FINGURU: ["-Comisión fija del 5%"],
  "RIVAROLA PAOLA": ["-Comisión fija del 13%"],
  "STABILE JORGELINA ROSA": ["-Comisión fija del 13%"],
  "CAROLINA MORANTE": ["-Comisión fija del 8%"],
  "RACIOPPE MARIA ESTER": ["-Comisión fija del 8%"],
  "BERON AGUSTINA": [
    "-Hasta $ 11.000.000 de capital 7%",
    "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
    "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
    "-Desde $ 30.000.001 hasta $ 60.000.000 de capital 11%",
    "-Más de $ 60.000.000 de capital 12%",
  ],
};

const defaultCommission = [
  "-Hasta $ 11.000.000 de capital 7%",
  "-Desde $ 11.000.001 hasta $ 20.000.000 de capital 9%",
  "-Desde $ 20.000.001 hasta $ 30.000.000 de capital 10%",
  "-En adelante 11%",
];

const normalize = (str) => (str || "").trim().replace(/\s+/g, " ").toUpperCase();

export const getCommissionDisplay = (supplierName) => {
  const normalizedSupplierName = normalize(supplierName);
  return specialCommissions[normalizedSupplierName] || defaultCommission;
};
